import React from 'react';
import './index.sass';
import { YMaps, Map, Placemark  } from 'react-yandex-maps';
import {ReactComponent as PhoneIcon} from './icons/phone.svg';
import {ReactComponent as EmailIcon} from './icons/mail.svg';
import {ReactComponent as AdressIcon} from './icons/address.svg';

const Contacts = () => {
    const coordinates = [55.733173, 37.427327]
    return (
        <section className="Contacts" id="contacts">
            <div className="Contacts__Aura" aria-hidden="true" />
            <div className="container Contacts__Container">
                <div className="Contacts__Inner">
                    <div className="Contacts__Box">
                        <div className="Contacts__Content">
                            <span className="Contacts__Eyebrow">Свяжитесь с нами</span>
                            <h2 className="Contacts__Title">
                                Обсудим <span className="Text-Accent">ваш проект</span>
                            </h2>
                            <p className="Contacts__Lead">
                                Расскажите о задаче — предложим архитектуру, команду и план.
                                Ответим в течение рабочего дня.
                            </p>
                            <div className="Contacts__Info">
                                <div className="Contacts__Row">
                                    <PhoneIcon className="Contacts__Icon" />
                                    <a className="Contacts__Text" href="tel:79153554802">
                                        +7 915 355 4802
                                    </a>
                                </div>
                                <div className="Contacts__Row">
                                    <EmailIcon className="Contacts__Icon" />
                                    <a className="Contacts__Text" href="mailto:info@smartsp.ru">
                                        info@smartsp.ru
                                    </a>
                                </div>
                                <div className="Contacts__Row">
                                    <AdressIcon className="Contacts__Icon" />
                                    <span className="Contacts__Text">
                                        г. Москва, ул. Молодогвардейская, 15, офис 112
                                    </span>
                                </div>
                            </div>
                            <a href="mailto:info@smartsp.ru" className="Contacts__Cta">
                                Написать нам
                            </a>
                        </div>
                        <div className="Contacts__Map">
                            <YMaps>
                                <Map defaultState={{ center: coordinates, zoom: 16 }} width='100%' height='100%'>
                                    <Placemark geometry={coordinates} />
                                </Map>
                            </YMaps>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contacts;
